import React from 'react'
import { useTranslation } from 'react-i18next'

const ProductsListCategory = ({ category, children }) => {

  const { i18n } = useTranslation()
  const lang = i18n.language 

  return (
    <div className="products-list-category">
      <div className="products-list-category-title">
        <span className="mainTitle">{category.acf.names[`name_${lang}`]}</span>
      </div>
      <div className="products-list-category-items">
        {children}
      </div>
    </div>
  )
}

export default ProductsListCategory